module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8279ce395d0333b880b8be6d243fd111.svg";